import PropTypes from 'prop-types';
import availableValuesPropType from './availableValuesPropType';

export default PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({
            to: PropTypes.string,
            from: PropTypes.string,
            today: PropTypes.bool
        }),
        PropTypes.arrayOf(PropTypes.string)
    ]),
    availableValues: availableValuesPropType,
    availableValuesLocation: PropTypes.string,
    fixed: PropTypes.bool,
    useValidation: PropTypes.bool,
    singleDay: PropTypes.bool,
    customEmptyValue: PropTypes.string,
    hideAllButton: PropTypes.bool,
    hideToday: PropTypes.bool,
    customSort: PropTypes.func
});
